export const PCOR_QUALITY_MEASURE = 'patient-care-metrics/';
export const PCOR_FILTER_TIN = 'standard-search/topfilter';

